module.exports = __webpack_public_path__ + "static/media/plantilla-Asociados.74738b11.csv";